import styled from 'styled-components';

export const ChatBotWrapper = styled.div`
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 999;
  display: flex;
  flex-direction: column-reverse;
  align-items: flex-end;
`;

export const ChatButton = styled.button`
  background: linear-gradient(90deg, #7b5cff, #60a5fa);
  color: #fff;
  border: none;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  font-size: 24px;
  cursor: pointer;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
`;

export const ChatPopup = styled.div`
  width: 350px;
  background-color: #ffffff;
  border: 1px solid #ddd;
  border-radius: 10px;
  margin-bottom: 10px;
  overflow: hidden;
  box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.2);
  display: ${(props) => (props.isOpen ? 'flex' : 'none')};
  flex-direction: column;
  max-height: 500px;
  position: absolute;
  bottom: 70px;
  right: 20px;
  z-index: 1000;

  /* Animation - only applied when actually in the DOM */
  transform: ${(props) => (props.isOpen ? 'scale(1)' : 'scale(0.8)')};
  opacity: ${(props) => (props.isOpen ? '1' : '0')};
  transition:
    transform 0.3s ease,
    opacity 0.3s ease;
  transform-origin: bottom right;
`;

export const ChatMessages = styled.div`
  flex: 1;
  padding: 15px;
  overflow-y: auto;
  max-height: 400px;
`;

export const Message = styled.div`
  background-color: ${(props) => (props.user ? '#2A8FF7' : '#f1f1f1')};
  color: ${(props) => (props.user ? '#fff' : '#333')};
  padding: 8px 12px;
  margin-bottom: 10px;
  border-radius: 8px;
  text-align: ${(props) => (props.user ? 'right' : 'left')};
  align-self: ${(props) => (props.user ? 'flex-end' : 'flex-start')};
  width: fit-content;
  font-size: 14px;
`;

export const UserInputWrapper = styled.div`
  display: flex;
  padding: 10px;
  border-top: 1px solid #ddd;
  background: #fafafa;
`;

export const UserInput = styled.input`
  flex: 1;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 8px;
  outline: none;
`;

export const SendButton = styled.button`
  background-color: #0084ff;
  color: white;
  border: none;
  padding: 10px 16px;
  border-radius: 8px;
  margin-left: 10px;
  cursor: pointer;
  font-size: 18px;

  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
`;

export const VoiceButton = styled.button`
  background: #f0f0f0;
  border: none;
  padding: 8px;
  margin: 0 4px;
  border-radius: 50%;
  cursor: pointer;
  font-size: 18px;

  &:hover {
    background: #ddd;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
`;

export const ListeningPopup = styled.div`
  position: absolute;
  bottom: 70px;
  left: 50%;
  transform: translateX(-50%);
  background: #fff;
  padding: 8px 16px;
  border-radius: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  color: #555;
  font-size: 14px;
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 15px;
  right: 15px;
  background: #f5f5f5;
  border: none;
  border-radius: 50%;
  width: 35px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 1001;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  transition: all 0.2s ease;
  color: #666;

  &:hover {
    background: #e0e0e0;
    transform: scale(1.05);
  }

  &:active {
    transform: scale(0.95);
  }

  &:focus {
    outline: 2px solid #007bff;
    outline-offset: 2px;
  }
`;

export const LogoWrapper = styled.div`
  width: 100%;
  height: 100%;
  padding: 1rem;
  border-radius: 50%;
  transition: all 0.3s ease;
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const Logo = styled.img`
  width: 40px;
  cursor: pointer;
`;
